import { createContext } from "react";

/**
 * 3D 素材地址（猫、演示用的水碗）。文件放在 PetJourneyWeb/dev-assets/avatar3d/，**不在 public/**：
 * 开发服务器（vite dev）按路径直接提供项目根下的文件，生产构建只复制 public/，所以 GLB 不进发布包
 * （REL-02 第 3.12 项：模型文件移出发布包；守卫见 tests/claude-6796-avatar3d-release-guard.test.ts）。
 * 3D 只在演示模式（fixture 数据 + ?cat3d=1）打开，生产（live）永远走 2D，不会去取这些地址。
 * 演示页可以用 Cat3DSourceContext 指到别处。
 */
export const CAT3D_ASSET_BASE = "/dev-assets/avatar3d/";
export const CAT3D_DEMO_URL = `${CAT3D_ASSET_BASE}cat-stray-demo-v3.glb`;
export const CAT3D_BOWL_URL = `${CAT3D_ASSET_BASE}bowl-tin-v1.glb`;
export const Cat3DSourceContext = createContext<string>(CAT3D_DEMO_URL);
